
  import { Component, Vue } from 'vue-property-decorator';
  import { Client, NetworkModel } from '@/services/api.service';
  import * as StringUtils from '@/utilities/string.utils';

  @Component({})
  export default class NetworkList extends Vue {
    private networks: NetworkModel[] = [];

    protected mounted() {
      this.fetchNetworks();
    }

    private fetchNetworks() {
      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);

      const networks = clientService.getNetworks().then(data => {
        const sortedData = data.sort((n1, n2) => StringUtils.stringCompare(n1.name || '', n2.name || ''));
        this.networks = sortedData;
      });
    }
  }
